/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Keen_Hamster_AspireInputs */

const fr_flat_keen_hamster_aspire = /** @type {(inputs: Flat_Keen_Hamster_AspireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actif depuis`)
};

/**

* @param {Flat_Keen_Hamster_AspireInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const flat_keen_hamster_aspire = /** @type {((inputs?: Flat_Keen_Hamster_AspireInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Keen_Hamster_AspireInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_flat_keen_hamster_aspire(inputs)
});